import React, { PropTypes } from 'react'
import Link from 'react-router/lib/Link'
import moment from 'moment'

const PaymentsDefault = ({ onSearchForm }) => (
  <div className="jumbotron">
    <h1>Payment Module</h1>
    <p>Make sure your date and time are correct!</p>
    <hr />
    <h3>{moment().format('LLL')}</h3>
    <hr/>
    <Link to="/payments/new" className="btn btn-info">New Payment</Link> or {' '}
    <button type="button" onClick={onSearchForm} className="btn btn-warning">
      Search Payments
    </button>
  </div>
)

PaymentsDefault.propTypes = {
  onSearchForm: PropTypes.func,
}

export default PaymentsDefault



// WEBPACK FOOTER //
// ./src/containers/Payments/default.js